<template>
  <div :class="$style.style">
    <div class="header-img">
      <div class="btn-upload" v-show="!disabled">
        <el-upload
          action="/upload"
          :show-file-list="false"
          :before-upload="beforeCardsUpload"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :on-success="handleSuccess">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </div>
      <div class="img-edit" v-show="!disabled">
        <div class="edit-div">
          <img :id="'image'+ckey" class="image" :src="imgSrc?imgSrc:'https://res.wx.qq.com/wxopenres/htmledition/images/spacer32f740.gif'"/>
        </div>
      </div>
      <div class="img-view">
        <div class="text">头像预览</div>
        <div class="square">
          <div class="preview"></div>
        </div>
        <div class="circle">
          <div class="preview"></div>
        </div>
      </div>
    </div>
    <!--
    <div>totalWidth:{{dataObj.totalWidth}}<br/>
        totalHeight: {{dataObj.totalHeight}},<br/>
        left: {{dataObj.left}},<br/>
        top: {{dataObj.top}},<br/>
        canvasWidth: {{dataObj.canvasWidth}},<br/>
        canvasHeight: {{dataObj.canvasHeight}},<br/>

        x: {{dataObj.x}},<br/>
        y: {{dataObj.y}},<br/>
        x1: {{dataObj.left/dataObj.totalWidth}},<br/>
        y1: {{dataObj.top/dataObj.totalHeight}},<br/>
        x2: {{(dataObj.left+dataObj.canvasWidth)/dataObj.totalWidth}},<br/>
        y2: {{(dataObj.top+dataObj.canvasHeight)/dataObj.totalHeight}},</div>-->
  </div>
</template>
<script>
  /*!
  * 裁剪控件：
  * https://github.com/fengyuanchen/cropperjs
  *
  * 参考：https://blog.csdn.net/leileibrother/article/details/78655371
  *
  * 参数：长宽比：ratio '1' 16/9 样式 show1 213.33*120 ; '2' 1 样式 show2 120*120
  * 
  */
import Cropper from 'cropperjs';
import axios from 'axios';
import { Message } from 'element-ui';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: { type: Object, default: {} },
    // imgSrc: { type: String, default: '' },
    ckey: { type: String, default: ''},
    disabled: { type: Boolean, default: false}
  },
  data () {
    return {
      headerImage:'',
      picValue:'',
      cropper:'',
      croppable:false,
      panel:false,
      url:'',
      imgCropperData: {
        accept: "image/gif, image/jpeg, image/png, image/jpg"
      },
      dataObj: {
        totalWidth: 0,
        totalHeight: 0,
        left: 0,
        top: 0,
        canvasWidth: 0,
        canvasHeight: 0,
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
      },
      imgSrc: '',
      result: this.value
    }
  },
  // computed:{
  //   result:function () {
  //     return this.value
  //   }
  // },
  mounted () {
    //初始化这个裁剪框
    var self = this;
    
    var image = document.getElementById('image'+this.ckey);
    var previews = document.querySelectorAll('.preview');
    this.cropper = new Cropper(image, {
      aspectRatio: 1,
      viewMode: 2,
      background:true,  // 方格背景
      zoomable:false,  // 能否缩放图片
      minContainerWidth: 100,
      ready: function () {
        // self.croppable = true;

        var clone = this.cloneNode();
        clone.className = '';
        clone.style.cssText = (
          'display: block;' +
          'width: 100%;' +
          'height: 100%;' +
          'min-width: 0;' +
          'min-height: 0;' +
          'max-width: none;' +
          'max-height: none;'
        );

        self.each(previews, function (elem) {
          elem.appendChild(clone.cloneNode());
        });
      },
      crop: function (event) {
        // debugger;
        var data = event.detail;
        var cropper = this.cropper;
        var imageData = cropper.getImageData();
        var previewAspectRatio = data.width / data.height;

        self.dataObj = {
          totalWidth: cropper.getImageData().naturalWidth,
          totalHeight: cropper.getImageData().naturalHeight,
          left: cropper.cropBoxData.left,
          top: cropper.cropBoxData.top,
          canvasWidth: cropper.getData().width,
          canvasHeight: cropper.getData().height,
          x: cropper.getData().x,
          y: cropper.getData().y
        }
        self.value = {
          imgSrc: self.imgSrc,
          x1: cropper.getData().x/cropper.getImageData().naturalWidth,
          y1: cropper.getData().y/cropper.getImageData().naturalHeight,
          x2: (cropper.getData().x+cropper.getData().width)/cropper.getImageData().naturalWidth,
          y2: (cropper.getData().y+cropper.getData().height)/cropper.getImageData().naturalHeight
        }

        self.each(previews, function (elem) {
          var previewImage = elem.getElementsByTagName('img').item(0);
          var previewWidth = elem.offsetWidth;
          var previewHeight = previewWidth / previewAspectRatio;
          var imageScaledRatio = data.width / previewWidth;

          elem.style.height = previewHeight + 'px';
          if (previewImage) {
            previewImage.style.width = imageData.naturalWidth / imageScaledRatio + 'px';
            previewImage.style.height = imageData.naturalHeight / imageScaledRatio + 'px';
            previewImage.style.marginLeft = -data.x / imageScaledRatio + 'px';
            previewImage.style.marginTop = -data.y / imageScaledRatio + 'px';
          }
        });
      },
    });
    console.log(this.value.imgSrc);
    if (this.result) {
      if (this.result.imgSrc) {
        this.cropper.replace(this.result.imgSrc);
      }
      if (this.result.x1) {

        this.cropper.setData(
        {
          "x": this.result.x1 * this.cropper.getImageData().naturalWidth,
          "y": this.result.y1 * this.cropper.getImageData().naturalHeight,
          "width": (this.result.x2 - this.result.x1) * this.cropper.getImageData().naturalWidth,
          "height": (this.result.x2 - this.result.x1) * this.cropper.getImageData().naturalWidth,
        });
      }
    }
    this.isFirst = true;
  },
  watch: {
    value: function(val) {
      this.result = val;
      // this.$emit('change', val);
      if(this.isFirst && this.result.imgSrc){
        console.log(this.value);
        if (this.result) {
          if (this.result.imgSrc) {
            // this.cropper.replace(this.result.imgSrc);
            this.handleSuccess({list: [this.result.imgSrc]});
          }
          if (this.result.x2) {

            this.cropper.setData(
            {
              "x": this.result.x1 * this.cropper.getImageData().naturalWidth,
              "y": this.result.y1 * this.cropper.getImageData().naturalHeight,
              "width": (this.result.x2 - this.result.x1) * this.cropper.getImageData().naturalWidth,
              "height": (this.result.x2 - this.result.x1) * this.cropper.getImageData().naturalWidth,
            });
            console.log(this.cropper.getData())
          }
        }
        this.isFirst = false;
      }
    },
    result: function(val) {
      this.$emit('change', val);
    }
  },
  methods: {
    each(arr, callback) {
      var length = arr.length;
      var i;

      for (i = 0; i < length; i++) {
        callback.call(arr, arr[i], i, arr);
      }

      return arr;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file);
    },
    //上传成功
    handleSuccess(file) {
      console.log(file);

      let self = this;
      if(file){
        this.imgSrc = file.list[0];
        // this.cropper.clear();
        this.cropper.replace(file.list[0]);

        var image = document.getElementById('image'+this.ckey);
        var previews = document.querySelectorAll('.preview');
        // self.each(previews, function (elem) {
        //   elem.appendChild('');
        // });
        let cropper;

        self.value = {
          imgSrc: file.list[0],
          x1: self.cropper.getData().x/self.cropper.getImageData().naturalWidth,
          y1: self.cropper.getData().y/self.cropper.getImageData().naturalHeight,
          x2: (self.cropper.getData().x+self.cropper.getData().width)/self.cropper.getImageData().naturalWidth,
          y2: (self.cropper.getData().y+self.cropper.getData().height)/self.cropper.getImageData().naturalHeight
        }
        this.$emit('change', self.result);

        image.addEventListener('ready', function () {
          console.log(this.cropper === cropper);
          var clone = this.cloneNode();
          clone.className = '';
          clone.style.cssText = (
            'display: block;' +
            // 'width: 100%;' +
            // 'height: 100%;' +
            'min-width: 0;' +
            'min-height: 0;' +
            'max-width: none;' +
            'max-height: none;'
          );
          let imageData = self.cropper.getImageData();
          let data = self.cropper.getData();
          let previewAspectRatio = data.width / data.height;

          self.each(previews, function (elem) {
              
            let previewWidth = elem.offsetWidth;
            let previewHeight = previewWidth / previewAspectRatio;
            let imageScaledRatio = data.width / previewWidth;

            elem.style.height = previewHeight + 'px';
            clone.style.width = imageData.naturalWidth / imageScaledRatio + 'px';
            clone.style.height = imageData.naturalHeight / imageScaledRatio + 'px';
            clone.style.marginLeft = -data.x / imageScaledRatio + 'px';
            clone.style.marginTop = -data.y / imageScaledRatio + 'px';

            if (elem.childNodes.length > 0) {
              elem.replaceChild(clone.cloneNode(),elem.childNodes[0]);
            } else {
              elem.appendChild(clone.cloneNode());
            }
            // elem.removeChild();
            // elem.appendChild(clone.cloneNode());
          });
        });
        cropper = new Cropper(image);
      }
    },// 
    beforeCardsUpload(file) {
      const isPic = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/gif';
      const isLt5M = file.size / 1024 / 1024 < 2;
      if (!isPic) {
        Message({
          type: 'warning',
          message: '图片格式必须为：png、bmp、jpeg、jpg、gif!'
        });
        return false;
      }
      if (!isLt5M) {
        Message({
          type: 'warning',
          message: '上传图片不能超过2MB'
        });
        return false;
      }
    },
  }
}
</script>
<style lang="less" module>
:local(.style) {
  margin: 0;  
  padding: 0;
  .header-img {
    height: 150px; 
    text-align: left;
    .btn-upload {
      display: inline-block;
      vertical-align: top;
    }
    .img-edit {
      display: inline-block;
      .edit-div {
        width: 150px;
        height: 150px;
        background: #F6F8F9;
      }
    }
    .img-view {
      display: inline-block;
      height: 150px;
      padding: 10px 20px;
      background: #F6F8F9;
      vertical-align: top;
      .text {
        line-height: 22px;
      }
      .square {
        height: 100px;
        width: 100px;
        display: inline-block;
        margin-right: 20px;
        .preview {
          overflow: hidden;
          border-radius: 4px;
          background:#fff;
        }
      }
      .circle {
        height: 100px;
        width: 100px;
        display: inline-block;
        .preview {
          overflow: hidden;
          height: 100px;
          border-radius: 50%;
          background:#fff;
        }
      }
    }
  }
  .header-img .image {  
    max-width: 100%;  
  }
  // cropper 样式
  .cropper-view-box,.cropper-face {  
    border-radius: 50%;  // 裁剪明亮图形圆角
  } 
  .cropper-container {
    // border: 1px solid #e7e7eb;
    background-color: #f6f8f9;
    // overflow: hidden;

    font-size: 0;  
    line-height: 0;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    direction: ltr;  
    -ms-touch-action: none;  
    touch-action: none
  }  

  .cropper-container img {  
    /* Avoid margin top issue (Occur only when margin-top <= -height) */  
    display: block;  
    min-width: 0 !important;  
    max-width: none !important;  
    min-height: 0 !important;  
    max-height: none !important;  
    width: 100%;  
    height: 100%;  
    image-orientation: 0deg  
  }
  .cropper-wrap-box,  
  .cropper-canvas,  
  .cropper-drag-box,  
  .cropper-crop-box,  
  .cropper-modal {  
    position: absolute;  
    top: 0;  
    right: 0;  
    bottom: 0;  
    left: 0;  
  }
  .cropper-wrap-box {  
    overflow: hidden;  
  }
  .cropper-drag-box {  
    opacity: 0;  
    background-color: #fff;  
  }
  .cropper-modal {  
    opacity: .5;  
    background-color: #000;  
  }
  .cropper-view-box {  
    display: block;  
    overflow: hidden;
    width: 100%;  
    height: 100%;
    outline: 1px solid #39f;  
    outline-color: rgba(51, 153, 255, 0.75);  
  }  

  .cropper-dashed {  
    position: absolute;
    display: block;
    opacity: .5;  
    border: 0 dashed #eee  
  }
  .cropper-dashed.dashed-h {  
    top: 33.33333%;  
    left: 0;  
    width: 100%;  
    height: 33.33333%;  
    border-top-width: 1px;  
    border-bottom-width: 1px  
  }
  .cropper-dashed.dashed-v {  
    top: 0;  
    left: 33.33333%;  
    width: 33.33333%;  
    height: 100%;  
    border-right-width: 1px;  
    border-left-width: 1px  
  }
  .cropper-center {  
    position: absolute;  
    top: 50%;  
    left: 50%;
    display: block;
    width: 0;  
    height: 0;
    opacity: .75  
  }
  .cropper-center:before,  
    .cropper-center:after {  
    position: absolute;  
    display: block;  
    content: ' ';  
    background-color: #eee  
  }
  .cropper-center:before {  
    top: 0;  
    left: -3px;  
    width: 7px;  
    height: 1px  
  }
  .cropper-center:after {  
    top: -3px;  
    left: 0;  
    width: 1px;  
    height: 7px  
  }
  .cropper-face,  
  .cropper-line,  
  .cropper-point {  
    position: absolute;
    display: block;
    width: 100%;  
    height: 100%;
    opacity: .1;  
  }
  .cropper-face {  
    top: 0;  
    left: 0;
    background-color: #fff;  
  }
  .cropper-line {  
    background-color: #39f  
  }
  .cropper-line.line-e {  
    top: 0;  
    right: -3px;  
    width: 5px;  
    cursor: e-resize  
  }
  .cropper-line.line-n {  
    top: -3px;  
    left: 0;  
    height: 5px;  
    cursor: n-resize  
  }
  .cropper-line.line-w {  
    top: 0;  
    left: -3px;  
    width: 5px;  
    cursor: w-resize  
  }
  .cropper-line.line-s {  
    bottom: -3px;  
    left: 0;  
    height: 5px;  
    cursor: s-resize  
  }
  .cropper-point {  
    width: 5px;  
    height: 5px;  

    opacity: .75;  
    background-color: #39f  
  }
  .cropper-point.point-e {  
    top: 50%;  
    right: -3px;  
    margin-top: -3px;  
    cursor: e-resize  
  }
  .cropper-point.point-n {  
    top: -3px;  
    left: 50%;  
    margin-left: -3px;  
    cursor: n-resize  
  }
  .cropper-point.point-w {  
    top: 50%;  
    left: -3px;  
    margin-top: -3px;  
    cursor: w-resize  
  }
  .cropper-point.point-s {  
    bottom: -3px;  
    left: 50%;  
    margin-left: -3px;  
    cursor: s-resize  
  }
  .cropper-point.point-ne {  
    top: -3px;  
    right: -3px;  
    cursor: ne-resize  
  }
  .cropper-point.point-nw {  
    top: -3px;  
    left: -3px;  
    cursor: nw-resize  
  }
  .cropper-point.point-sw {  
    bottom: -3px;  
    left: -3px;  
    cursor: sw-resize  
  }
  .cropper-point.point-se {  
    right: -3px;  
    bottom: -3px;  
    width: 20px;  
    height: 20px;  
    cursor: se-resize;  
    opacity: 1  
  }
  @media (min-width: 768px) {
    .cropper-point.point-se {  
      width: 15px;  
      height: 15px  
    }  
  }
  @media (min-width: 992px) {
    .cropper-point.point-se {  
      width: 10px;  
      height: 10px  
    }  
  }
  @media (min-width: 1200px) {
    .cropper-point.point-se {  
      width: 5px;  
      height: 5px;  
      opacity: .75  
    }  
  }
  .cropper-point.point-se:before {  
    position: absolute;  
    right: -50%;  
    bottom: -50%;  
    display: block;  
    width: 200%;  
    height: 200%;  
    content: ' ';  
    opacity: 0;  
    background-color: #39f  
  }
  .cropper-invisible {  
    opacity: 0;  
  }
  .cropper-bg {  
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');  
  }
  .cropper-hide {  
    position: absolute;
    display: block;
    width: 0;  
    height: 0;  
  }
  .cropper-hidden {  
    display: none !important;  
  }
  .cropper-move {  
    cursor: move;  
  }
  .cropper-crop {  
    cursor: crosshair;  
  }
  .cropper-disabled .cropper-drag-box,  
  .cropper-disabled .cropper-face,  
  .cropper-disabled .cropper-line,  
  .cropper-disabled .cropper-point {  
    cursor: not-allowed;  
  }

}
</style>